import type { MediaPlayerStore } from './MediaPlayerStore';

export type MediaSource = MediaPlayerStore['mediaSrc'];

export const normalizeMediaUrl = (src: string) =>
  window.location.hostname === 'localhost' && window.location.port === '4000'
    ? src.replace('https://static.easyllama.com', '/easyllama')
    : src;

export const normalizeMediaSource = (source: MediaSource): MediaSource =>
  typeof source === 'string'
    ? normalizeMediaUrl(source)
    : source.map(({ src, type }) => ({ src: normalizeMediaUrl(src), type }));

export const mediaSourcesMatch = (
  current: MediaSource,
  expected: MediaSource
) =>
  typeof expected === 'string' && Array.isArray(current)
    ? current.some(source => source.src === normalizeMediaUrl(expected))
    : JSON.stringify(current) ===
      JSON.stringify(normalizeMediaSource(expected));
